/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/** Writes the API access token to a cookie for Unity WebGL asset proxy authentication. */
const COOKIE_NAME = 'access_token';
const COOKIE_PATH = '/api/v1/assets';
// Older sessions wrote the cookie on /api; expire that scope so it stops riding every JSON call.
const LEGACY_COOKIE_PATH = '/api';

export function mirrorAccessTokenToCookie(token: string | null | undefined): void {
  /* v8 ignore next -- defensive: document is always present in the browser runtime. */
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=; path=${LEGACY_COOKIE_PATH}; Max-Age=0; SameSite=Lax${secure}`;
  if (!token) {
    // Expire stale cookie when signed out or token acquisition fails.
    document.cookie = `${COOKIE_NAME}=; path=${COOKIE_PATH}; Max-Age=0; SameSite=Lax${secure}`;
    return;
  }
  document.cookie = `${COOKIE_NAME}=${token}; path=${COOKIE_PATH}; SameSite=Lax${secure}`;
}
